const generateDefaultTokenName = () => {
  const options = { year: 'numeric', month: 'short', day: 'numeric' }
  const currentDate = new Date().toLocaleDateString('en-US', options)

  return `Instance – ${currentDate}`
}

export default generateDefaultTokenName
